import React from 'react';
import { Typography } from '@mui/material';
import { Translate } from 'react-localize-redux';
import { PlacementLesion } from './photoPlacement';

const T = 'hospital.patient.photo-placement';

/** "Chest · Lesion": what the reviewer recognises a lesion by, after its number. */
export default function LesionFacts({ lesion }: { lesion: PlacementLesion }) {
    const facts = [
        lesion.bodyRegion && { id: 'body-region', value: lesion.bodyRegion },
        lesion.target && { id: 'target', value: lesion.target },
    ].filter((fact): fact is { id: string; value: string } => !!fact);
    if (facts.length === 0) return null;
    return (
        <Typography variant="body2" color="text.secondary">
            {facts.map((fact, index) => (
                <React.Fragment key={fact.id}>
                    {index > 0 && ' · '}
                    <Translate id={`${T}.${fact.id}`} />: {fact.value}
                </React.Fragment>
            ))}
        </Typography>
    );
}
